import {Form, InputNumber, App,    Row, Col, DatePicker, Space   } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './cost.module.css'
import Icon from '../../cpn/Icon';
import { useDingdanzhichuAddMutation, useFKaddtijiaoMutation } from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';  
import ClientBankSelect from '../../system/client/ClientBankSelect';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import UploadPic from '../../cpn/UploadPic';
import dayjs from 'dayjs';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
import CostNodeAdd from './CostNodeAdd';
import ArapTypeSelect from '../../cpn/ArapTypeSelect';
function CostListAdd(props) {
    const { message } = App.useApp();
    // 若 props 中企业 id/名 为空或 0，则从本地存储读取
    const qy_id = (props.qy_id === 0 || props.qy_id === null || props.qy_id === undefined || props.qy_id === '')
        ? (JSON.parse(localStorage.getItem('jtg-caiwu_qy_id')) ?? props.qy_id)
        : props.qy_id;
    const qy_name = (props.qy_name === '' || props.qy_name === undefined)
        ? (JSON.parse(localStorage.getItem('jtg-caiwu_qy_name')) ?? props.qy_name)
        : props.qy_name;

    const [info,setInfo] = useState({
        'ddzc_price': '',//保存团队客户id
        'ddzc_uid': '',
        'ddzc_uname': '',
        'ddzc_content': '',
        'ddzc_bzd_id': '',
        'ddzc_qy_id': '',
        'ddzc_qy_name': '',
        'ddzc_kh_id': '',
        'ddzc_kh_name': '',
        'ddzc_type_id': '',//保存团队客户类型id
        'ddzc_type_name': '',//保存团队客户类型名称
        'ddzc_amount': '',
        'ddzc_bzd_xuhao': '',
        'ddzc_bzd_name': '',
        'ddzc_date': '',
        'ddzc_bzd_date_end': '',
        'ddzc_num': '',//保存团队客户名称
        'ddzc_name': '',
        'ddzc_bzd_date': '',
        'ddzc_khyhzh_id': '',
        'ddzc_khyhzh_name': '',
        'ddzc_image_name': '',
        'ddzc_image_file': '',
        'ddzc_bm_id': '',
        'ddzc_bm_name': '',
        'ddzc_state': '1',
        'ddzc_zflx': ''
    })
    const [form] = Form.useForm();
    const [add] = useDingdanzhichuAddMutation();
    useEffect(() => {
        // 确保ddzc_date有默认值，同时更新其他相关字段
        if (!info.ddzc_date || props.dsbzd_date !== info.ddzc_date || props.dsbzd_date_end !== info.ddzc_date_end) {
            setInfo(prevState => ({
                ...prevState,
                ddzc_date: props.dsbzd_date || new Date().toISOString().split('T')[0],
                ddzc_date_end: props.dsbzd_date_end || new Date().toISOString().split('T')[0],
                ddzc_bzd_name: props.dsbzd_name || prevState.ddzc_bzd_name,
                ddzc_bzd_danhao: props.dsbzd_danhao || prevState.ddzc_bzd_danhao,
                ddzc_bzd_id: props.dsbzd_id || prevState.ddzc_bzd_id
            }))
        }
    }, [props, info.ddzc_date, info.ddzc_date_end])

    // 当Modal打开时设置表单值
    useEffect(() => {
        if (props.dsbzd_date && props.dsbzd_date_end) {
            form.setFieldsValue({
                ddzc_bzd_name: props.dsbzd_danhao + ' ' + props.dsbzd_name,
            })
        }
        // 设置表单字段的初始值
        form.setFieldsValue({
            ddzc_price: 0.01,
            ddzc_num: 1,
            ddzc_amount: ''
        })
    }, [props, form])

    //提交
    const [addtijiao] = useFKaddtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <div style={{width:'100%',height:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
            <Form
                form={form}
                className={classes.form}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                initialValues={{
                    ddzc_date: props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                    ddzc_bm_id: props.dsbzd_bm_id ? props.dsbzd_bm_id : undefined,
                    ddzc_bm_name: props.dsbzd_bm_name ? props.dsbzd_bm_name : undefined,
                }}
                style={{ maxWidth: 1480,backgroundColor:'#fff',padding:'20px 30px'}}
            >
                    <Row style={{width:"1280px"}}>
                    <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid green',borderLeft:'3px solid green'}}></Col>
                    <Col span={16} className={classes.row_top_middle} style={{color:'green',borderTop:'3px solid green'}}>付款单</Col>
                    <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid green',borderRight:'3px solid green'}}></Col>
                    {/* 第一行 */}
                    <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid green',color:'green'}}>团队名称</Col>
                    <Col span={6}  className={classes.col_top_input} style={{padding: '15px'}}>
                        {props.dsbzd_name}
                    </Col>  
                    <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                    <Col span={6}  className={classes.col_top_input}>
                        {props.dsbzd_dscp_id && props.dsbzd_dscp_name && <div>{props.dsbzd_dscp_name}</div>}
                    </Col>  
                    <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                    <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid green'}}>
                    {props.dsbzd_kh_id && props.dsbzd_kh_name && <div>{props.dsbzd_kh_name}</div>}
                    </Col> 
                    {/* 第二行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 日期</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <Form.Item name='ddzc_date' noStyle>
                            <DatePicker 
                                placeholder='请选择日期' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, ddzc_date: value }))
                                }}
                                style={{ width: '100%' }}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <Form.Item name='ddzc_amount' noStyle>
                            <InputNumber 
                                placeholder='请输入金额' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, ddzc_amount: value }))
                                }}
                                style={{ width: '100%' }}
                                min={0.01}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                    <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid green'}}>
                        <ReportDeptSelect
                            yh_id={props.yh_id}
                            wrapperCol={{span:24}}
                            placeholder='请选择部门'
                            qy_id={qy_id}
                            onChange={(e,f) => {
                                setInfo(prevState => ({ ...prevState, ddzc_bm_id: e, ddzc_bm_name: f }))
                            }}
                            name="ddzc_bm_name"
                            defaultId={info.ddzc_bm_id}
                            style={{ width: '100%' }}
                            formStyle={{marginBottom: 0,width: '100%'}}
                        />
                    </Col>
                    {/* 第三行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 付款客户</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <ClientSelect
                            name='ddzc_kh_name'
                            placeholder='请选择付款客户'
                            onChange={(value,label) => {
                                setInfo(prevState => ({ ...prevState, ddzc_kh_id: value, ddzc_kh_name: label }))
                            }}
                            style={{width: '230px'}}
                            formStyle={{marginBottom: 0,width: '100%'}}
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            defaultId={info.ddzc_kh_id}
                            wrapperCol={{span:24}}
                            clientAdd={true}
                        />
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                    <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid green'}}>
                        <ClientBankSelect
                            name='ddzc_khyhzh_name'
                            placeholder='请选择借款客户银行'
                            onChange={(value,label) => {
                                setInfo(prevState => ({ ...prevState, ddzc_khyhzh_id: value, ddzc_khyhzh_name: label }))
                            }}
                            style={{ width: '100%' }}
                            formStyle={{marginBottom: 0,width: '100%'}}
                            wrapperCol={{span:24}}
                            qy_id={qy_id}
                            yh_id={props.yh_id}
                            defaultId={info.ddzc_khyhzh_id}
                            kh_id={info.ddzc_kh_id}
                        />
                    </Col>
                      {/* 第四行       */}
                      <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 往来类型</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <ArapTypeSelect 
                                documentType='cost' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, ddzc_zflx: value }))
                                }}
                                name='ddzc_zflx'
                                required={true}
                                style={{marginBottom: 0}}
                                wrapperCol={{span:24}}
                            />
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>备注</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddzc_content' noStyle>
                               <OCRTextArea
                                   value={info.ddzc_content}
                                   onChange={(e) => {
                                       setInfo(prevState => ({ ...prevState, ddzc_content: e.target.value }))
                                   }}
                                   language="chi_sim"
                               />
                           </Form.Item>
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                       <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid green'}}>
                            
                       </Col>                             
                       {/* 第五行       */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}>编号/状态</Col>
                       <Col span={6}  className={classes.col_middle_input}>                            
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>附件</Col>
                       <Col span={14}  className={classes.col_bottom_input} style={{borderRight:'3px solid green'}}>
                           <UploadPic
                               name='ddzc_image'
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, ddzc_image_file: e, ddzc_image_name: f }))
                               }}
                               maxCount={5}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                           />
                       </Col>                
                    {/* 第六行 */}
                    <Col span={24} className={classes.bottom_row}>
                        <CostNodeAdd qy_id={qy_id} user_id={props.yh_id} yh_name={props.yh_name}/>
                    </Col>
                </Row>  
                <Row>
                    <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                        <DocumentRule/>
                        <Space size={20}>
                            <Icon 
                                key='submit' 
                                type='save' 
                                onClick={() => {
                                    
                                    if(info.ddzc_amount === ''){  
                                        message.error('请输入金额');
                                        return;
                                    }
                                    
                                    if(info.ddzc_kh_id === ''){
                                        message.error('请选择客户');
                                        return;
                                    } 
                                    if(info.ddzc_date === ''){
                                        message.error('请选择日期');
                                        return;
                                    }
                                    if(info.ddzc_khyhzh_id === ''){
                                        message.error('请选择银行账户');
                                        return;
                                    }
                                    if(info.ddzc_bm_id === ''){
                                        message.error('请选择部门');
                                        return;
                                    }
                                    if(info.ddzc_zflx === ''){
                                        message.error('请选择往来类型');
                                        return;
                                    }
                                    add({
                                        'ddzc_price': props.dsbzd_kh_id?props.dsbzd_kh_id:'',
                                        'ddzc_uid': props.yh_id,
                                        'ddzc_uname': props.yh_name,
                                        'ddzc_content': info.ddzc_content,
                                        'ddzc_bzd_id': props.dsbzd_id?props.dsbzd_id:'',
                                        'ddzc_qy_id': qy_id,
                                        'ddzc_qy_name': qy_name,
                                        'ddzc_kh_id': info.ddzc_kh_id,
                                        'ddzc_kh_name': info.ddzc_kh_name,
                                        'ddzc_type_id': props.dsbzd_dscp_id?props.dsbzd_dscp_id:'',
                                        'ddzc_type_name': props.dsbzd_dscp_name?props.dsbzd_dscp_name:'',
                                        'ddzc_amount': info.ddzc_amount,
                                        'ddzc_bzd_xuhao': '',
                                        'ddzc_bzd_name': props.dsbzd_name?props.dsbzd_name:'',
                                        'ddzc_date': info.ddzc_date ? info.ddzc_date:props.dsbzd_date,
                                        'ddzc_bzd_date_end': props.dsbzd_date_end?props.dsbzd_date_end:'',
                                        'ddzc_num': props.dsbzd_kh_name?props.dsbzd_kh_name:'', 
                                        'ddzc_name': info.ddzc_name,
                                        'ddzc_bzd_date': props.dsbzd_date?props.dsbzd_date:'',
                                        'ddzc_khyhzh_id': info.ddzc_khyhzh_id,
                                        'ddzc_khyhzh_name': info.ddzc_khyhzh_name,
                                        'ddzc_image_name': info.ddzc_image_name?info.ddzc_image_name:'',
                                        'ddzc_image_file': info.ddzc_image_file?info.ddzc_image_file:'',
                                        'ddzc_bm_id': info.ddzc_bm_id,
                                        'ddzc_bm_name': info.ddzc_bm_name,
                                        'ddzc_state': '1',
                                        'ddzc_zflx': info.ddzc_zflx,
                                        'spdd_sp_id': '14',
                                        'spdd_sp_name': '财务管理',
                                        'spdd_spgg_id': '19',
                                        'spdd_spgg_name': '付款单',
                                        'spdd_spgg_price': '0.1',
                                        'spdd_state': '支出'
                                    }).then(res => {
                                        if(res.data.Status==='success'){
                                            message.success('新增成功');
                                            form.resetFields();  
                                        }else{
                                            message.error('新增失败！' + res.data.Message);
                                        }
                                    })     
                                }}
                            />
                            <Icon 
                                key='reset' 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields()
                                    setInfo(prevState => ({ 
                                        ...prevState, 
                                        ddzc_price:'', 
                                        ddzc_num:1, 
                                        ddzc_amount:'', 
                                        ddzc_content:'',                             
                                        ddzc_type_id:'', 
                                        ddzc_type_name:'', 
                                        ddzc_kh_id:'', 
                                        ddzc_kh_name:'', 
                                        qy_id: qy_id,
                                        qy_name: qy_name,
                                        ddzc_zflx: ''
                                    }))
                                    // 重置后重新设置表单字段的默认值
                                    form.setFieldsValue({
                                        ddzc_price: '',
                                        ddzc_num: 1,
                                        ddzc_amount: ''
                                    })
                                }}
                            />
                            <Icon
                                type='submit'
                                title='提交'
                                disabled={isSubmitting}
                                style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                onClick={() => {
                                    // 如果正在提交中，直接返回
                                    if (isSubmitting) {
                                        return;
                                    }
                                    
                                    // 先进行验证
                                    if(info.ddzc_amount === ''){
                                        message.error('请输入金额');
                                        return;
                                    }
                                    
                                    if(info.ddzc_kh_id === ''){
                                        message.error('请选择客户');
                                        return;
                                    }
                                    if(info.ddzc_khyhzh_id === ''){
                                        message.error('请选择银行账户');
                                        return;
                                    }                                       
                                    if(info.ddzc_bm_id === ''){
                                        message.error('请选择部门');
                                        return;
                                    }
                                    if(info.ddzc_date === ''){
                                        message.error('请选择日期');
                                        return;
                                    }
                                    if(info.ddzc_zflx === ''){
                                        message.error('请选择往来类型');
                                        return;
                                    }
                                    // 验证通过后，设置提交状态
                                    setIsSubmitting(true);
                                    addtijiao({
                                        'ddzc_type_id': props.dsbzd_dscp_id?props.dsbzd_dscp_id:'',
                                        'ddzc_type_name': props.dsbzd_dscp_name?props.dsbzd_dscp_name:'',
                                        'ddzc_amount': info.ddzc_amount,
                                        'ddzc_qy_id': qy_id,
                                        'ddzc_qy_name': qy_name,
                                        'ddzc_num': props.dsbzd_kh_name?props.dsbzd_kh_name:'',
                                        'ddzc_zflx': info.ddzc_zflx,
                                        'ddzc_uid': props.yh_id,
                                        'ddzc_uname': props.yh_name,
                                        'ddzc_name': props.dsbzd_name?props.dsbzd_name:'',
                                        'ddzc_date': info.ddzc_date?info.ddzc_date:props.dsbzd_date,
                                        'ddzc_kh_id': info.ddzc_kh_id,
                                        'ddzc_kh_name': info.ddzc_kh_name,
                                        'ddzc_price': props.dsbzd_kh_id?props.dsbzd_kh_id:'',
                                        'ddzc_content': info.ddzc_content,
                                        'ddzc_bzd_id': props.dsbzd_id?props.dsbzd_id:''   ,
                                        'ddzc_bzd_name': props.dsbzd_name?props.dsbzd_name:'',
                                        'ddzc_bzd_date': props.dsbzd_date?props.dsbzd_date:'',
                                        'ddzc_bzd_xuhao': '',
                                        'ddzc_bzd_date_end': props.dsbzd_date_end?props.dsbzd_date_end:'',
                                        'ddzc_khyhzh_id': info.ddzc_khyhzh_id,
                                        'ddzc_khyhzh_name': info.ddzc_khyhzh_name,
                                        'ddzc_bm_id': info.ddzc_bm_id,
                                        'ddzc_bm_name': info.ddzc_bm_name,
                                        'ddzc_image_name': info.ddzc_image_name?info.ddzc_image_name:'',
                                        'ddzc_image_file': info.ddzc_image_file?info.ddzc_image_file:'',
                                        'ddzc_state': '1'
                                    }).then(res => {
                                        if(res.data.Status==='success'){
                                            message.success('提交成功');
                                            setIsSubmitting(false);                                            
                                            form.resetFields();  
                                        }else{
                                            message.error('提交失败！' + res.data.Message);
                                        }
                                    })     
                                }}
                            /> 
                        </Space> 
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default CostListAdd